import React, { useContext } from 'react';
import { BooksContext } from '../Root/Root';

import {
    Legend, Line, LineChart, ReferenceLine, Tooltip, XAxis,
    YAxis
} from "recharts";

const Statistic = () => {
    const data = useContext(BooksContext);

    return (
        <div className="md:w-3/5 mx-auto mt-10">

            <LineChart width={450} height={300} data={data.data}
                margin={{
                    top: 20, right: 50, left: 20, bottom: 5
                }}>
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <ReferenceLine y="Page C" stroke="red" label="Max PV PAGE" />
                <ReferenceLine x={9800} label="Max" stroke="red" />
                <Line type="monotone" dataKey="total" stroke="#8884d8" />
            </LineChart>
        </div>
    );
};

export default Statistic;